import { useNavItems } from '@/hooks/useNavItems'

import styles from './HeaderNav.module.scss'
import { HeaderNavDropdown } from './HeaderNavDropdown/HeaderNavDropdown'

export const HeaderNav = () => {
  const items = useNavItems(styles, 'desktop')

  return (
    <nav className={styles.container} role='navigation'>
      <ul className={styles.menuMain}>
        {items.submenu?.map((item) => (
          <HeaderNavDropdown item={item} key={item.id} />
        ))}
      </ul>
    </nav>
  )
}
